import { Input } from 'antd';
import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { AppState } from 'src/config/appState';

import { changeSingleValueQuestionAnswer } from '../actions/surveysActions';
import { QuestionComponentBaseProps, SurveyTextQuestionAnswer } from '../models/surveys';
import { getProgramSurveySingleQuestionAnswer } from '../selectors/surveysSelectors';
import { QuestionHeader } from './QuestionHeader';

interface StateProps {
    answer: SurveyTextQuestionAnswer | undefined;
}

interface ActionsProps {
    changeSingleValueQuestionAnswer: typeof changeSingleValueQuestionAnswer;
}

type Props = QuestionComponentBaseProps & StateProps & ActionsProps & WithTranslation;

export class TextAreaQuestionContainer extends React.Component<Props> {
    public handleInputChange = ({ target }: React.ChangeEvent<HTMLTextAreaElement>) => {
        const { programId, surveyId, id } = this.props;

        this.props.changeSingleValueQuestionAnswer({
            programId,
            surveyId,
            question: id,
            value: target.value,
        });
    };

    public render(): JSX.Element {
        const {
            question,
            placeholder = this.props.t('placeholders.textInput'),
            answer,
            readableIndex,
        } = this.props;

        return (
            <>
                {question && <QuestionHeader index={readableIndex} header={question} />}
                <Input.TextArea
                    rows={5}
                    placeholder={placeholder}
                    value={answer && answer.data.content}
                    onChange={this.handleInputChange}
                />
            </>
        );
    }
}

const mapStateToProps = (state: AppState, { programId, surveyId, id }: Props): StateProps => ({
    answer: getProgramSurveySingleQuestionAnswer(state, programId, surveyId, id) as
        | SurveyTextQuestionAnswer
        | undefined,
});

export const TextAreaQuestion = withTranslation()(
    connect(mapStateToProps, {
        changeSingleValueQuestionAnswer,
    })(TextAreaQuestionContainer),
);
